export default "__VITE_ASSET__BAEjGGhU__"